import { useState } from "react";
import axios from "axios";

export default function AdminSignup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://haaterkaj-backend-1.onrender.com/api/admin/signup", {
        name,
        email,
        password,
      });

      alert("Admin Registered ✅ Now Login");

      window.location.href = "/admin/login";
    } catch (err) {
      alert("Signup Failed. Maybe admin already exists.");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <form onSubmit={handleSignup}
        className="bg-white p-6 rounded-lg shadow-lg w-80 space-y-4"
      >
        <h2 className="text-xl font-bold text-center">Admin Signup</h2>

        <input type="text" placeholder="Full Name"
          className="border p-2 w-full"
          onChange={(e) => setName(e.target.value)} required />

        <input type="email" placeholder="Email"
          className="border p-2 w-full"
          onChange={(e) => setEmail(e.target.value)} required />

        <input type="password" placeholder="Password"
          className="border p-2 w-full"
          onChange={(e) => setPassword(e.target.value)} required />

        <button className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded">
          Create Admin
        </button>

        <p className="text-center text-sm">
          Already Admin? <a href="/admin/login" className="text-blue-600 underline">Login</a>
        </p>
      </form>
    </div>
  );
}
